import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl, FormGroup } from '@cancercentrum/rcc-bootstrap';
import debounce from 'lodash/debounce';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export const SimpleColumnFilter = ({ value, onValueChange })=>{
    const [val, setVal] = useState(value);
    const onValueChangeRef = useRef(onValueChange);
    onValueChangeRef.current = onValueChange;
    const handleOnChange = useCallback((newValue)=>{
        onValueChangeRef.current(newValue);
    }, []);
    const dbFn = useMemo(()=>debounce(handleOnChange, 500), [
        handleOnChange
    ]);
    const debouncedOnChange = useCallback((newValue)=>dbFn(newValue), [
        dbFn
    ]);
    const isActiveFilter = (value ?? '').length > 0;
    // Synka ev. ändringar i filterstate utifrån
    useEffect(()=>{
        setVal(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ _jsx(FormGroup, {
        validationState: isActiveFilter ? 'success' : undefined,
        children: /*#__PURE__*/ _jsx(FormControl, {
            type: "text",
            bsSize: "sm",
            value: val,
            onChange: (e)=>{
                setVal(e.target.value);
                debouncedOnChange(e.target.value);
            }
        })
    });
};
export function defaultSimpleColumnFilter(items, filterString, getValue) {
    if (!filterString) {
        return items;
    }
    return items.filter((x)=>(getValue(x) || '').toString().toLowerCase().includes(filterString.toLowerCase()));
}
